import { ref, createApp, onMounted } from 'vue'

const app = createApp({
  setup() {
    const navState = ref(false)
    const subNavState = ref(false)
    const scrollButton = document.getElementById('scrollButton')
    const fixedLogo = document.getElementById('fixedLogo')
    const mainVisual = document.getElementById('mainVisual')
    // onMounted(() => {
    //   const subNav = document.getElementById('subNav')
    // })
    const handle = (event: any) => {
      event.preventDefault()
    }
    const toggleNav = () => {
      navState.value = !navState.value
      if (mainVisual) {
        if (navState.value) {
          scrollButton?.classList.remove('active')
          fixedLogo?.classList.remove('active')
          document.addEventListener('touchmove', handle, { passive: false })
          document.addEventListener('mousewheel', handle, { passive: false })
        } else if (window.scrollY > mainVisual.clientHeight) {
          scrollButton?.classList.add('active')
          fixedLogo?.classList.add('active')
          document.removeEventListener('touchmove', handle)
          document.removeEventListener('mousewheel', handle)
        } else {
          document.removeEventListener('touchmove', handle)
          document.removeEventListener('mousewheel', handle)
        }
      } else {
        if (navState.value) {
          scrollButton?.classList.remove('active')
          fixedLogo?.classList.remove('active')
          document.addEventListener('touchmove', handle, { passive: false })
          document.addEventListener('mousewheel', handle, { passive: false })
        } else {
          scrollButton?.classList.add('active')
          fixedLogo?.classList.add('active')
          document.removeEventListener('touchmove', handle)
          document.removeEventListener('mousewheel', handle)
        }
      }
    }
    const menuOpen = () => {
      subNavState.value = true
    }
    const menuClose = () => {
      subNavState.value = false
      // @ts-ignore
      subNav!.classList.remove('active')
    }
    const navClose = () => {
      navState.value = false
      document.removeEventListener('touchmove', handle)
      document.removeEventListener('mousewheel', handle)
    }
    return { navState, subNavState, toggleNav, menuOpen, menuClose, navClose }
  }
})
if (document.getElementById('headerSP') != null) {
  app.mount('#headerSP')
}
